import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';

var fn = function fn($scope, $state, lobConfig, $window, $q, $stateParams, CancellationService, ActivityService, $modal, ModalService, $filter, UserService, $translate, InsuranceSuiteMetadata, defaultLocaleDetails, $rootScope) {

    var ctrl = Object.create(BaseCtrl);

    var phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        $scope.cancellationNumber = $stateParams.cancellationNumber;
        $scope.policyNumber = $rootScope.policyNumber;
        console.log("policynumber ***");
        console.log($rootScope);
        $scope.loadingCancellationPromise = CancellationService.findJobByJobNumber($stateParams.cancellationNumber, $scope.policyNumber).then(function (cancellation) {
            if (!cancellation.statusCode) {
                ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
                $state.go('policies.index');
            }

            $scope.accountInfo = {};

            mapCancellationDetails(cancellation);
            mapAccountDetails(cancellation.policy.account);

            if ($scope.cancellation.statusCode === 'NotTaken') {
                $scope.isNotTaken = true;
            }
        }, function () {
            ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
            $state.go('policies.index');
        });

        updateSummaryFromServer();

        $scope.$watchGroup(['bindCancellationPromise', 'withdrawCancellationPromise'], function () {
            $scope.cancellationActionPromise = $q.all([$scope.bindCancellationPromise, $scope.withdrawCancellationPromise]);
        });
    };

    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }

        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateCancellation;

        setupAccountContactDetails(accountDetails.accountHolder);
    }

    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    function mapCancellationDetails(cancellation) {
        console.log('CancellationDetailCtrl.mapCancellationDetails');
        console.log('cancellation', cancellation);
        $scope.cancellation = cancellation;
        console.log("**after bind cancellation**");
        //$state.reload();
        $scope.latestPeriod = cancellation.policy.latestPeriod;
        $scope.policyNumber = cancellation.policy.policyNumber;
        $scope.createTime = cancellation.createTime;

        //$scope.cancellationRefundMethod = 'pro rata';
        $scope.cancellationReason = InsuranceSuiteMetadata.get('pc').types.getTypelist('ReasonCode').getCode(cancellation.cancelReasonCode).name;
        //$scope.cancellationRefundMethod = InsuranceSuiteMetadata.get('pc').types.getTypelist('CalculationMethod').getCode(cancellation.cancellationRefundMethod).name;
        //$scope.cancellationIsDraft = cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name;
        //$scope.cancellationIsCancelling = cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Canceling').name;

        if ($scope.cancellation.isRefund) {
            $scope.cancellation.changeInCost.amount *= -1;
        }

        if (!$scope.cancellation.description) {
            $scope.cancellation.description = '-';
        }
    }

    ctrl.goBack = function () {
        console.log('goBack()');
        $window.history.back();
    };

    ctrl.bindCancellation = function (cancellationNumber) {
        var message = $translate('gateway.views.cancellation-detail.You won\'t be able to undo once bound.').then(function (msg) {
            return $translate('gateway.views.cancellation-detail.Are you sure you want to bind this cancellation?').then(function (secondMsg) {
                return msg + ' ' + secondMsg;
            });
        });
        var modalPromise = ModalService.showConfirm('gateway.views.cancellation-detail.Bind Cancellation', message, undefined, $filter('translate')('gateway.views.cancellation-detail.Bind Cancellation'), undefined, $filter('translate')('gateway.views.cancellation-detail.Do Not Bind')).result;

        modalPromise.then(function () {
            $scope.bindCancellationPromise = CancellationService.bindCancellation(cancellationNumber).then(function (cancellation) {
                mapCancellationDetails(cancellation);
                //$state.reload();
            }, function () {
                mapCancellationDetails(cancellation);
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.cancellation-detail.This transaction cannot be completed at this time. Please contact Montana State Fund at 406-495-5000 or toll-free at 1-800-332-6102 for assistance.');
            });
        });
    };

    ctrl.submitCancellation = function (cancellationNumber) {
        var modalPromise = ModalService.showConfirm('gateway.views.cancellation-detail.Bind Cancellation', $filter('translate')('gateway.views.cancellation-detail.Are you sure you want to bind this cancellation?'), undefined, $filter('translate')('gateway.views.cancellation-detail.Bind Cancellation'), undefined, $filter('translate')('gateway.views.cancellation-detail.Do Not Bind')).result;

        modalPromise.then(function () {
            $scope.submitCancellationPromise = CancellationService.bindCancellation(cancellationNumber).then(function (cancellation) {
                mapCancellationDetails(cancellation);
                //$state.reload();
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.cancellation-detail.Failed to bind cancellation');
            });
        });
    };

    ctrl.withdrawCancellationByCancellationNumber = function (cancellationNumber) {
        var modalPromise = ModalService.showConfirm('gateway.views.cancellation-detail.Withdraw Cancellation', $translate('gateway.views.cancellation-detail.Are you sure you want to withdraw the cancellation?'), undefined, $filter('translate')('gateway.views.cancellation-detail.Withdraw Cancellation'), undefined, $filter('translate')('gateway.views.cancellation-detail.Do Not Withdraw')).result;

        modalPromise.then(function () {
            $scope.withdrawCancellationPromise = CancellationService.withdrawCancellationByCancellationNumber(cancellationNumber).then(function (cancellation) {
                mapCancellationDetails(cancellation);
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.cancellation-detail.Failed to withdraw cancellation');
            });
        });
    };

    function updateSummaryFromServer() {
        $scope.cancellationSummaryRequestPromise = CancellationService.getCancellationSummary($stateParams.cancellationNumber).then(function (cancellationSummary) {
            $scope.cancellationSummary = cancellationSummary;
        }, function () {});
    }

    $scope.$on('notesUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('documentsUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('activitiesUpdated', function () {
        updateSummaryFromServer();
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', 'lobConfig', '$window', '$q', '$stateParams', 'CancellationService', 'ActivityService', '$modal', 'ModalService', '$filter', 'UserService', '$translate', 'InsuranceSuiteMetadata', 'defaultLocaleDetails', '$rootScope'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/CancellationDetailCtrl.js
// module id = 1666
// module chunks = 0